import PropTypes from "prop-types"
import parse from "html-react-parser"

import thumbsUp from "images/partners/feedback/thumbs-up.svg?raw"
import thumbsDown from "images/partners/feedback/thumbs-down.svg?raw"

import SmallAppletCard from "./applet_card/ifttt_next/small_applet_card"

export const PlatformAppletList = ({ appletsPathsFeedbacks }) => (
  <ul className="web-applet-cards">
    {appletsPathsFeedbacks.map(a => (
      <li
        className="my-web-applet-card web-applet-card"
        data-applet-id={a.applet.id}
        key={a.applet.id}
      >
        <SmallAppletCard applet={a.applet} appletPath={a.path} />
        {a.published && (
          <a href={a.path} className="applet-feedback-rating">
            <span className="rating-container">
              <span className="thumbs up">{parse(thumbsUp)}</span>
              <span>{a.feedback.like}</span>
            </span>
            <span className="rating-bar">
              <span
                className="positive-rating-bar"
                style={{
                  width: a.feedback.ratings_count
                    ? Math.round(
                        (a.feedback.like / a.feedback.ratings_count) * 100
                      )
                    : 0,
                }}
              />
              <span
                className="negative-rating-bar"
                style={{
                  width: a.feedback.ratings_count
                    ? Math.round(
                        (a.feedback.dislike / a.feedback.ratings_count) * 100
                      )
                    : 0,
                }}
              />
            </span>
            <span className="rating-container">
              <span className="thumbs down">{parse(thumbsDown)}</span>
              <span>{a.feedback.dislike}</span>
            </span>
          </a>
        )}
        <div className="applet-admin-controls">
          <a
            href={a.url}
            className="open-in-new link-inline"
            target="_blank"
            title="View on IFTTT"
            rel="noreferrer"
          />
        </div>
      </li>
    ))}
  </ul>
)

PlatformAppletList.propTypes = {
  appletsPathsFeedbacks: PropTypes.arrayOf(
    PropTypes.shape({
      applet: PropTypes.object.isRequired,
      path: PropTypes.string.isRequired,
      feedback: PropTypes.object,
      url: PropTypes.string.isRequired,
      published: PropTypes.bool.isRequired,
    })
  ),
}
